import { render, staticRenderFns } from "./DowntimeMigrate.vue?vue&type=template&id=a4c47da2&"
import script from "./DowntimeMigrate.vue?vue&type=script&lang=js&"
export * from "./DowntimeMigrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports